import React, { useState, useEffect } from 'react';
import { Filter, TextInput, ReferenceInput, ReferenceField, SelectInput, List, Datagrid, TextField, Loading } from 'react-admin';
import dataProvider from '../../providers/dataProvider';

const FilterByNameAndCategory = (props) => (
  <Filter {...props}>
    <TextInput label="Search" source="name" alwaysOn />
    <ReferenceInput label="Categoria" source="category_id" reference="category" alwaysOn allowEmpty={false}>
      <SelectInput optionText="name" />
    </ReferenceInput>
  </Filter>
);

// GET /service agora exige pelo menos um filtro (category_id, ids, name ou
// feature_ids) — sem filtro, o index carregava e serializava o catálogo
// global inteiro, estourando o timeout de 30s e derrubando os pods
// (PRIT-3891, prit-api). Sem uma categoria padrão aqui, essa tela abriria
// chamando a API sem filtro nenhum antes do admin digitar ou escolher
// qualquer coisa, e cairia direto num 400 — por isso busca a primeira
// categoria antes de montar a lista.
const ServiceList = props => {
  const [defaultCategoryId, setDefaultCategoryId] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    dataProvider('GET_LIST', 'category', {
      pagination: { page: 1, perPage: 1 },
      sort: { field: 'name', order: 'ASC' },
      filter: {},
    })
      .then(({ data }) => setDefaultCategoryId(data[0] ? data[0].id : null))
      .catch(() => setDefaultCategoryId(null))
      .finally(() => setLoading(false));
  }, []);

  if (loading) return <Loading />;

  return (
    <List
      {...props}
      filters={<FilterByNameAndCategory />}
      filterDefaultValues={defaultCategoryId ? { category_id: defaultCategoryId } : undefined}
      sort={{ field: 'name', order: 'ASC' }}
      bulkActionButtons={false}
    >
      <Datagrid rowClick="edit">
        <TextField source="name" />
        <ReferenceField label="Categoria" source="categoryId" reference="category" allowEmpty>
          <TextField source="name" />
        </ReferenceField>
        <ReferenceField label="Pricing Type" source="pricingTypeId" reference="pricing_type" allowEmpty>
          <TextField source="name" />
        </ReferenceField>
        <TextField source="nameEng" />
        <TextField source="namePort" />
        <TextField source="price" />
        <TextField source="duration" />
      </Datagrid>
    </List>
  );
};

export default ServiceList;
